export default __webpack_public_path__ + "static/media/Helical-Coil-Double-wrap.26469fff.jpg";